import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Jobs = lazy(() => import('../Jobs'));

const JobsRoutes: RouteObject[] = [
  {
    path: 'jobs',
    element: <Jobs />,
  },
];

export default JobsRoutes;
